"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useTrackingData } from "@/contexts/tracking/tracking.context";
import { useJpmuid } from "@/hooks/tracking/jpmuid/use-jpmuid.hook";
import { useTracking } from "@/hooks/tracking/use-tracking";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
export function usePageViewTracking() {
  const $ = _c(8);
  const {
    emit
  } = useTracking();
  const {
    user
  } = useAuthentication();
  const {
    jpmuid
  } = useJpmuid();
  const consent = useCookiebotConsent();
  const {
    trackingData
  } = useTrackingData();
  const {
    absolute: currentUrl
  } = useCurrentUrl();
  const lastTrackedUrl = useRef(null);
  let t0;
  let t1;
  if ($[0] !== consent || $[1] !== currentUrl || $[2] !== emit || $[3] !== jpmuid || $[4] !== trackingData || $[5] !== user) {
    t0 = () => {
      if (trackingData === null || !consent.submitted) {
        return;
      }
      if (lastTrackedUrl.current === currentUrl) {
        return;
      }
      emit({
        event: "page-view",
        model: {
          consent,
          currentUrl,
          jpmuid,
          trackingData,
          user
        }
      });
      lastTrackedUrl.current = currentUrl;
    };
    t1 = [emit, consent, trackingData, currentUrl, jpmuid, user];
    $[0] = consent;
    $[1] = currentUrl;
    $[2] = emit;
    $[3] = jpmuid;
    $[4] = trackingData;
    $[5] = user;
    $[6] = t0;
    $[7] = t1;
  } else {
    t0 = $[6];
    t1 = $[7];
  }
  useEffect(t0, t1);
}